export const PROPERTY_LEVELS = {
  PROJECT: 'project',
  OBJECT: 'object',
} as const;
